// Navigation functionality
document.addEventListener('DOMContentLoaded', function () {
	console.log('Jaeckle theme loaded!');

	// Mobile menu toggle
	const mobileToggle = document.querySelector('.mobile-menu-toggle');
	const mobileNav = document.querySelector('.mobile-navigation');

	if (mobileToggle && mobileNav) {
		mobileToggle.addEventListener('click', function () {
			const isExpanded = this.getAttribute('aria-expanded') === 'true';

			// Toggle aria attributes
			this.setAttribute('aria-expanded', !isExpanded);
			mobileNav.setAttribute('aria-hidden', isExpanded);

			// Toggle active class
			mobileNav.classList.toggle('active');

			// Prevent body scroll when menu is open
			document.body.style.overflow = isExpanded ? '' : 'hidden';
		});

		// Close menu when clicking outside (on overlay)
		mobileNav.addEventListener('click', function (e) {
			if (e.target === this) {
				mobileToggle.click();
			}
		});

		// Close menu on escape key
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && mobileNav.classList.contains('active')) {
				mobileToggle.click();
			}
		});
	}

	// Desktop menu items with submenus are now clickable links
	// Submenus open on hover (handled by CSS), links work normally

	// Mobile submenu toggle functionality
	const mobileMenuItemsWithChildren = document.querySelectorAll(
		'.mobile-menu .menu-item-has-children'
	);

	mobileMenuItemsWithChildren.forEach(menuItem => {
		const toggle = menuItem.querySelector('.submenu-toggle');
		const submenu = menuItem.querySelector('.sub-menu');

		if (toggle && submenu) {
			// Toggle submenu when chevron is clicked
			toggle.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				const isExpanded = this.getAttribute('aria-expanded') === 'true';

				// Toggle aria-expanded
				this.setAttribute('aria-expanded', !isExpanded);

				// Toggle submenu visibility
				submenu.classList.toggle('active');
			});
		}
	});

	// Search toggle buttons (placeholder for future search modal)
	const searchToggles = document.querySelectorAll('.search-toggle');

	searchToggles.forEach(toggle => {
		toggle.addEventListener('click', function () {
			console.log('Search clicked - search modal to be implemented');
			// TODO: Open search modal when implemented
		});
	});
});
